export const environment = {
  production: true,
  hmr: false,
  limitAccessToSubjectsByOrg: false,
  allowAdminsToCreateOrganisations: false,
  timeRecordingInMinutes: false,
  enableCasePreparationFeatures: false,
  enableGridSizing: false,
  enableGeoLocation: false,
  enableFOIFeature: false,
  enableMobileView: false,
  enableBIDashboardAccess: false,
  currentUserIsMultiOrgAdmin: false,
  enableRetentionFeature: false,
  appName: 'AABInCase365',
  appInsights: {
    instrumentationKey: 'f46aa2a5-6bcc-44ff-a972-d749131b5a87',
  },
};
